<template>
  <div id="media">
    <div class="header-nav">
      <a class="tab-item" :class="{active: i == $store.state.newsTabI}" v-for="(v, i) in menu_list" :key="i" @click="tabHandle(v)">{{v.cnName}}</a>
    </div>
    <div class="nav-wrap" :class="{'video-wrap': $store.state.newsTabI === 1}">
      <div class="nav-title">{{$store.state.newsTabI ? '视频': '新闻'}}</div>
    </div>
    <router-view />
  </div> 
</template>

<script>

import {getColumns} from '@/api/home'
import {imgError} from '@/assets/utility.js'

export default {
  data() {
    return {
      banner: {
        imgUrl: ''
      },
      title: '',
      menu_list: [],
    }
  },
  mounted() {
    this.$store.commit('setCurrentMenuI', 5)
    getColumns(this.$route.params.cid).then(res => {
      if (res) {
        this.menu_list = res[0].subList
      }
    })
  },
  methods: {
    tabHandle(v) {
      this.title = v.cnName
      let route = v.targetUrl.replace("/","")
      route = route === 'news' ? "" : route
      this.$router.push({
        path: `/media/${v.topId}/`+route,
        query:{
          colId: v.colId
        }
      })
    },
    imgError(pUrl) {
      imgError(pUrl)
    },
    goArtcle(pData) {
      this.$router.push(`/article/${pData.id}`)
    }
  }
}
</script>

<style lang="scss">
  .new-trends {
    background-color: #fff;
    h2 {
      margin: 0;
      text-align: center;
      font-weight: 400;
      color: #333333;
    }
    .new-trends-list {
      display: flex;
      flex-wrap: wrap;
      .new-trends-item {
        position: relative;
        cursor: pointer;
        .new-trends-img {
          position: relative;
          .title {
            position: absolute;
            bottom: 0;
            display: block;
            box-sizing: border-box;
            width: 100%;
            text-align: center;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 768px) {
    #media_home {
      padding: 0 rem(225);
    }
    .video-wrap {
      padding: 0 rem(135) 0 rem(75);
    }
    .new-trends {
      margin: 0 rem(225);
      padding: rem(30) rem(50);
      h2 {
        font-size: rem(36);
      }
      .new-trends-list {
        padding: rem(50);
        .new-trends-item {
          margin-right: rem(40);
          margin-bottom: rem(40);
          width: rem(350);
          .new-trends-img {
            height: rem(207);
            .bg-img {
              border-radius: rem(48);
            }
            .title {
              padding: rem(20) rem(41);
              font-size: rem(21);
              line-height: rem(34);
            }
          }
          .title {
            display: none;
          }
        }
        .new-trends-item:nth-child(3n){
          margin-right: 0;
        }
      }
    }
  }
  @media only screen and (max-width: 768px) {
    #media_home {
      padding: 0 .575rem;
    }
    .battle-tab {
      margin-top: .74rem;
    }
    .new-trends {
      padding: .3rem .57rem;
      h2 {
        font-size: 0.48rem;
      }
      .new-trends-list {
        padding-top: .5rem;
        .new-trends-item {
          margin-right: .31rem;
          margin-bottom: .31rem;
          width: 3.02rem;
          .new-trends-img {
            height: 1.6rem;
            .bg-img {
              border-radius: .25rem;
            }
          }
          .title {
            padding: .25rem 0;
            font-size: 0.3rem;
            font-weight: 500;
            color: #333333;
            line-height: 0.4rem;
          }
        }
        .new-trends-item:nth-child(2n){
          margin-right: 0;
        }

      }
    }
  }
</style>
